import { smoothScrollEventListener } from '../../src/utilities/utilities';
import React from 'react';
import ReactDOM from 'react-dom';
import DevexHighOrderComponent from '../../src/components/react/devex_high_order_component/devex_high_order_component';
import DataGatheringBannerBootstrap5 from '../../src/components/react/data_gathering_banner/bootstrap_5/data_gathering_banner_bootstrap_5';

// Styles
import '../../src/career_account/styles/global_styles.scss';

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('career-account-data-gathering');
  if (root) {
    ReactDOM.render(
      <DevexHighOrderComponent>
        <DataGatheringBannerBootstrap5 requestedField={root.dataset.requestedField} />
      </DevexHighOrderComponent>,
      root
    );
  }

  const navbarContainer = document.getElementById('navbar-container');
  const navbar = document.getElementById('career-center-navbar');
  const isMobile = navbar.dataset.isMobile === 'true';

  if (!isMobile) {
    document.addEventListener('scroll', function makeNavbarSticky() {
      const position = navbarContainer.getBoundingClientRect();
      const height = Math.floor(position.height);

      if (position.top <= -height) {
        navbar.classList.add('affixed');
      }

      if (position.top > -height) {
        navbar.classList.remove('affixed');
      }
    });
  }

  smoothScrollEventListener('#resumes-section-link', 'resumes-section');
  smoothScrollEventListener('#find-job-section-link', 'find-job-section');
  smoothScrollEventListener('#trending-section-link', 'trending-section');
  smoothScrollEventListener('#working-with-section-link', 'working-with-section');
  smoothScrollEventListener('#advice-section-link', 'advice-section');
});
